import { useState } from 'react'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/view/components/ui/dialog'
import { Button } from '@/view/components/ui/button'
import { PinInput } from '@/view/pages/Perfil/components/UserPin/components/PinInput'
import { CurrentUserResponse } from '@/app/services/usersService/user'

interface ConfirmationTransactionModalProps {
  isOpen: boolean
  onClose: React.Dispatch<React.SetStateAction<boolean>>
  clientName: string
  pin: string[]
  setPin: React.Dispatch<React.SetStateAction<string[]>>
  submitForm: (e?: React.BaseSyntheticEvent) => Promise<void>
  user: CurrentUserResponse | undefined
}

export function ConfirmationTransactionModal({
  isOpen,
  onClose,
  clientName,
  pin,
  setPin,
  submitForm,
  user,
}: ConfirmationTransactionModalProps) {
  const [step, setStep] = useState<'confirm' | 'pin'>('confirm')

  const handleConfirm = async () => {
    if (step === 'confirm') {
      setStep('pin')
      return
    }

    onClose(false)
  }

  const handleClose = () => {
    setStep('confirm')
    setPin([''])
    onClose(false)
  }

  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <DialogContent className="max-sm:w-[95vw] max-sm:max-w-none sm:max-w-md">
        {step === 'confirm' ? (
          <>
            <DialogHeader>
              <DialogTitle className="text-xl font-semibold">
                Confirmar envio
              </DialogTitle>
              <DialogDescription className="text-sm font-medium text-black04">
                Você está prestes a enviar uma proposta para{' '}
                <span className="font-semibold text-black">{clientName}</span>.
                Tem certeza disso?
              </DialogDescription>
            </DialogHeader>
            <DialogFooter className="flex gap-2 max-sm:flex-col max-sm:gap-3 sm:justify-end">
              <Button
                variant="outline"
                onClick={handleClose}
                className="rounded-full max-sm:order-2"
              >
                Cancelar
              </Button>
              <Button
                type={user?.isPinProtected ? 'button' : 'submit'}
                onClick={user?.isPinProtected ? handleConfirm : submitForm}
                className="rounded-full text-white max-sm:order-1"
              >
                Confirmar
              </Button>
            </DialogFooter>
          </>
        ) : (
          <>
            <DialogHeader>
              <DialogTitle>Verificação de segurança</DialogTitle>
              <DialogDescription>
                Digite seu PIN de 4 dígitos para confirmar a operação
              </DialogDescription>
            </DialogHeader>
            <div className="flex w-5/6 justify-center py-6 max-sm:w-full max-sm:py-4">
              <PinInput pin={pin} setPin={setPin} />
            </div>
            <DialogFooter className="flex gap-2 max-sm:flex-col max-sm:gap-3 sm:justify-end">
              <Button
                variant="outline"
                onClick={handleClose}
                className="rounded-full max-sm:order-2"
              >
                Cancelar
              </Button>
              <Button
                type="submit"
                onClick={submitForm}
                className="rounded-full text-white max-sm:order-1"
              >
                Confirmar
              </Button>
            </DialogFooter>
          </>
        )}
      </DialogContent>
    </Dialog>
  )
}
